import {
  CheckCircleIcon,
  ClockIcon,
  ClipboardDocumentIcon,
  TruckIcon
} from "@heroicons/react/24/outline";

const STATUS_CONFIG = {
  active: {
    label: "Active",
    icon: CheckCircleIcon,
    container: "bg-green-600/20",
    textColor: "text-green-600",
    iconColor: "text-green-600",
    iconAnimation: "hover:animate-pulse"
  },
  pending: {
    label: "Pending",
    icon: ClockIcon,
    container: "bg-yellow-600/20",
    textColor: "text-yellow-500",
    iconColor: "text-yellow-500",
    darkIconColor: "text-yellow-500",
    iconAnimation: "hover:animate-spin"
  },
  planned: {
    label: "Planned",
    icon: ClipboardDocumentIcon,
    container: "bg-blue-600/20",
    textColor: "text-blue-500",
    iconColor: "text-blue-500",
    darkIconColor: "text-blue-500",
    iconAnimation: "hover:animate-spin"
  },
  shipped: {
    label: "Shipped",
    icon: TruckIcon,
    container: "bg-shippedColor border",
    textColor: "text-shippedColor",
    darkContainer: "bg-shippedColor text-black",
    iconAnimation: "hover:animate-spin"
  }
};

const StatusBadge = ({ status, darkMode }) => {
  const config = STATUS_CONFIG[status];

  if (!config) return null;

  return (
    <span
      className={`
        inline-flex items-center gap-x-1.5 rounded-lg px-3 py-1.5 text-xs font-medium
        ${darkMode ? config.darkContainer || config.container : config.container} ${config.textColor}
      `}
    >
      <svg
        viewBox="0 0 6 6"
        aria-hidden="true"
        className={`size-1.5 ${darkMode ? config.darkIconColor || config.iconColor : config.iconColor} fill-current`}
      >
        <circle r={3} cx={3} cy={3} />
      </svg>
      <span className="leading-none">
        {config.label}
      </span>
    </span>
  );
};

export default StatusBadge;
